import React, { Fragment } from "react";
import { Anchor, Type } from "discover.medical.react-component-library";
import { logDrugBNFClicked } from "../../util/analytics";
import { SeeAlsoWrapper } from "./_.styled";

const SeeAlso = ({ links }) => {
  const handleOnClick = (label) => {
    logDrugBNFClicked(label);
  };
  return (
    <SeeAlsoWrapper>
      <Type element="span" textTransform="uppercase" fontSize="sm">
        See Also:{" "}
      </Type>
      {links?.map((link, index) => (
        <Fragment key={link.label}>
          <Anchor
            href={link.route}
            glyph={link.glyph}
            onClick={() => handleOnClick(link.label)}
            fontSize="sm"
            rel="noopener noreferrer"
            target="_blank"
          >
            {link.label}
          </Anchor>
          {index < links.length - 1 ? ", " : ""}
        </Fragment>
      ))}
    </SeeAlsoWrapper>
  );
};

export default SeeAlso;
